import { Divider, Grid, Stack } from '@mui/material';

import { useMovementMenuOptions } from '../../hooks';
import { ServiceItem } from '../ServiceItem';
import { SectionTitle } from '../ServiceItem/styles';

export function GroupedServices() {
  const { activeContractServices, fixedServices, newContractServices } =
    useMovementMenuOptions();

  return (
    <Stack p={3} gap={3}>
      <Grid container spacing={2}>
        {fixedServices.map(item => (
          <Grid item xs={6} key={item.title}>
            <ServiceItem
              primary={item.primary}
              title={item.title}
              icon={item.icon}
              description={item.description}
              redirects={item.redirects}
              type={item.type}
            />
          </Grid>
        ))}
      </Grid>

      <Divider />

      <SectionTitle>Gestão de novos beneficiários</SectionTitle>
      <Grid container spacing={2}>
        {newContractServices.map(item => (
          <Grid item xs={6} key={item.title}>
            <ServiceItem
              primary={item.primary}
              title={item.title}
              description={item.description}
              icon={item.icon}
              redirects={item.redirects}
              type={item.type}
            />
          </Grid>
        ))}
      </Grid>

      <Divider />

      <SectionTitle>Gestão de beneficiários ativos</SectionTitle>
      <Grid container spacing={2}>
        {activeContractServices.map(item => (
          <Grid item xs={6} key={item.title}>
            <ServiceItem
              primary={item.primary}
              title={item.title}
              description={item.description}
              icon={item.icon}
              redirects={item.redirects}
              type={item.type}
            />
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}
